/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyReturnBillPayment from './pharmacy-return-bill-payment';
import PharmacyReturnBillPaymentDetail from './pharmacy-return-bill-payment-detail';
import PharmacyReturnBillPaymentUpdate from './pharmacy-return-bill-payment-update';
import PharmacyReturnBillPaymentDeleteDialog from './pharmacy-return-bill-payment-delete-dialog';

const PharmacyReturnBillPaymentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyReturnBillPayment />} />
    <Route path="new" element={<PharmacyReturnBillPaymentUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyReturnBillPaymentDetail />} />
      <Route path="edit" element={<PharmacyReturnBillPaymentUpdate />} />
      <Route path="delete" element={<PharmacyReturnBillPaymentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyReturnBillPaymentRoutes;
